/** Help page: everyday tasks step by step, each with a screenshot whose numbered boxes match the numbered steps. */
export const help = {
  nav: "How-to guide",
  title: "How-to guide",
  intro: "Everyday tasks, step by step. The numbers on each picture match the numbered steps next to it.",
  tourTitle: "Getting started guide",
  tourBody: "A four-step walk through the console that opens each page for you. About five minutes.",
  tourStart: "Start the guide again",
  figAlt: "Screenshot: {title}",
  sections: {
    deposits: {
      title: "Check a player's deposit",
      lead: "When a player says their money hasn't arrived:",
      steps: [
        "Search box at the top of every page: type the player ID or the transaction ID. You don't need to open any page first.",
        "Search box on the Deposits page: the same search, plus filters for status, coin and date.",
        "Status: “Confirmed” means the money has arrived. “Detected” means it is on its way: wait a minute or two.",
        "Transaction ID: open it to see the transfer on the blockchain website, or copy it to check with the player.",
      ],
    },
    payout: {
      title: "Send money to a player",
      lead: "Most payouts are sent by your website automatically. To send one by hand: Payouts → New payout.",
      steps: [
        "Pick the coin and network. It must be the same network as the player's wallet address.",
        "Paste the player's wallet address. Copy and paste it, never type it, then check the first and last few characters.",
        "Enter the amount.",
        "The fee, what the player receives and what comes off your balance are worked out for you here.",
        "Click Review, check everything once more and confirm with your 6-digit code. Above the approval limit it waits for a second person. Money that has been sent can't be taken back.",
      ],
    },
    approve: {
      title: "Approve a large payout",
      lead: "Payouts → Waiting for approval, then open the payout.",
      steps: [
        "Amount: check it is right.",
        "Wallet address: check it is the player's address.",
        "All good? Click Approve and enter your code.",
        "Not sure? Click Reject and write why; the money goes back to your balance. You can't approve a payout you created yourself.",
      ],
    },
    topup: {
      title: "Add money to the vault",
      lead: "When the vault runs low, payouts wait in a queue. Vault → Top up vault.",
      steps: [
        "Check which network and coin this is.",
        "This is the vault address. Send USDT here from any wallet or exchange.",
        "Copy the address with this button; never type it.",
        "Only send this coin on this network, anything else is lost. It counts automatically once it arrives, with no fee.",
      ],
    },
    statement: {
      title: "Reconcile with the statement",
      lead: "The statement works like a bank statement.",
      steps: [
        "Pick the coin and network you want to see.",
        "In and Out: every deposit credited and every payout held, sent or returned.",
        "Balance: what is left after each line.",
        "Export a spreadsheet for your accounts team.",
      ],
    },
    invite: {
      title: "Invite a colleague",
      lead: "Team → Invite member.",
      steps: [
        "Enter your colleague's email.",
        "Pick a role: Finance can send and approve payouts, Viewer can only look.",
        "Pick which brands they can work on.",
        "Create the invite link and send it to them privately. It works once and expires in 72 hours.",
      ],
    },
    telegram: {
      title: "Approve payouts in Telegram (owners)",
      lead: "Click your name at the top right → Security settings → Telegram approvals.",
      steps: [
        "Click Open bot and press Start in Telegram. The bot replies with a number.",
        "Paste that number here.",
        "Enter the 6-digit code from the authenticator app on your phone.",
        "Click Link Telegram, then go back to Telegram and tap Confirm link. Large payouts then reach your phone and take two taps to approve.",
      ],
    },
  },
};
